module.exports = __webpack_public_path__ + "static/media/news-15.bf2502eb.jpg";